/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {TombOfNefertitiBackground} from "./background/TombOfNefertitiBackground";
import {TombOfNefertitiRandomCursePresentationController} from "./beforespinstoppresentation/curseOfNefertiti/TombOfNefertitiRandomCursePresentationController";
import {TombOfNefertitiWildRaidPresentationController} from "./beforespinstoppresentation/wildRaider/TombOfNefertitiWildRaidPresentationController";
import {TombOfNefertitiPolyBetline} from "./betline/line/TombOfNefertitiPolyBetline";
import {TombOfNefertitiTextBetlineNumber} from "./betline/number/TombOfNefertitiTextBetlineNumber";
import {TombOfNefertitiBetLinesView} from "./betline/TombOfNefertitiBetlinesView";
import {TombOfNefertitiGameShaker} from "./gameshake/TombOfNefertitiGameShaker";
import {TombOfNefertitiMainGameIdleAnimationController} from "./idleAnimation/mainGameIdleAnimation/TombOfNefertitiMainGameIdleAnimationController";
import {TombOfNefertitiSymbolIdleAnimationController} from "./idleAnimation/symbolIdleAnimation/TombOfNefertitiSymbolIdleAnimationController";
import {TombOfNefertitiIntroView} from "./intro/TombOfNefertitiIntroView";
import {TombOfNefertitiLogo} from "./logo/TombOfNefertitiLogo";
import {TombOfNefertitiMultiplier} from "./multiplierIndicator/TombOfNefertitiMultiplier";
import {TombOfNefertitiReelController} from "./reel/reel/TombOfNefertitiReelController";
import {TombOfNefertitiReelPartAnimator} from "./reel/reel/TombOfNefertitiReelPartAnimator";
import {TombOfNefertitiReelAreaView} from "./reel/reelarea/TombOfNefertitiReelAreaView";
import {TombOfNefertitiReels} from "./reel/reelarea/TombOfNefertitiReels";
import {TombOfNefertitiScatterAttentionController} from "./reel/scatterAttention/TombOfNefertitiScatterAttentionController";
import {TombOfNefertitiReelStopPresentationController} from "./reelStopPresentation/TombOfNefertitiReelStopPresentationController";
import {TombOfNefertitiFreeSpinIntroController} from "./screen/freespinintro/TombOfNefertitiFreeSpinIntroController";
import {TombOfNefertitiFreeSpinIntroView} from "./screen/freespinintro/TombOfNefertitiFreeSpinIntroView";
import {TombOfNefertitiFreeSpinOutroController} from "./screen/freespinoutro/TombOfNefertitiFreeSpinOutroController";
import {TombOfNefertitiFreeSpinOutroView} from "./screen/freespinoutro/TombOfNefertitiFreeSpinOutroView";
import {TombOfNefertitiParsedGameData} from "./server/data/TombOfNefertitiParsedGameData";
import {TombOfNefertitiParsedInitData} from "./server/data/TombOfNefertitiParsedInitData";
import {TombOfNefertitiServerDataParser} from "./server/TombOfNefertitiServerDataParser";
import {TombOfNefertitiSpinController} from "./spin/TombOfNefertitiSpinController";
import {TombOfNefertitiReelSymbolStateCreator} from "./symbols/TombOfNefertitiReelSymbolStateCreator";
import {TombOfNefertitiFontConfig} from "./TombOfNefertitiFontConfig";
import {TombOfNefertitiGameAssets} from "./TombOfNefertitiGameAssets";
import {TombOfNefertitiGameConfig} from "./TombOfNefertitiGameConfig";
import {TombOfNefertitiSoundConfig} from "./TombOfNefertitiSoundConfig";
import {TombOfNefertitiAnimatedWinlineController} from "./winpresentation/animatedwinlines/TombOfNefertitiAnimatedWinlineController";
import {TombOfNefertitiBigWinController} from "./winpresentation/bigwin/TombOfNefertitiBigWinController";
import {TombOfNefertitiInitCurseRespinController} from "./winpresentation/curse/TombOfNefertitiInitCurseRespinController";
import {TombOfNefertitiFreeSpinTotalWinController} from "./winpresentation/freeSpinTotalWin/TombOfNefertitiFreeSpinTotalWinController";
import {TombOfNefertitiBetLineWinIndividualWPController} from "./winpresentation/individualwin/TombOfNefertitiBetLineWinIndividualWPController";
import {TombOfNefertitiInitialWPController} from "./winpresentation/initial/TombOfNefertitiInitialWPController";
import {TombOfNefertitiNoWinSymbolsWinPresentationController} from "./winpresentation/nowinsymbols/TombOfNefertitiNoWinSymbolsWinPresentationController";
import {TombOfNefertitiFSRespinZeroBetController} from "./zerobet/respinZeroBet/TombOfNefertitiFSRespinZeroBetController";
import {TombOfNefertitiRespinZeroBetController} from "./zerobet/respinZeroBet/TombOfNefertitiRespinZeroBetController";

export class TombOfNefertitiGameModuleConfig implements IGameModuleConfig {

    public static instance:TombOfNefertitiGameModuleConfig = new TombOfNefertitiGameModuleConfig();
    public static multiplier:TombOfNefertitiMultiplier;
    private static gameTweakerTest:GameTweakerTest;
    private static background:TombOfNefertitiBackground;
    private static betLinesView:TombOfNefertitiBetLinesView;
    private static animatedWinlineController:TombOfNefertitiAnimatedWinlineController;
    private static logo:TombOfNefertitiLogo;
    private static attention:TombOfNefertitiScatterAttentionController;
    private static gameShaker:TombOfNefertitiGameShaker;

    GAME_CONFIG:IGameConfig = TombOfNefertitiGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = TombOfNefertitiSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = TombOfNefertitiFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = TombOfNefertitiGameAssets.RESOURCES_GROUPS;

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new TombOfNefertitiNoWinSymbolsWinPresentationController(indexes, {noWinStateFadeInDuration : 1})],
        [indexes => new TombOfNefertitiInitialWPController(indexes)],
        [indexes => new TombOfNefertitiBigWinController(indexes)],
        [indexes => new TombOfNefertitiInitCurseRespinController(indexes)],
        [indexes => new TombOfNefertitiFreeSpinTotalWinController(indexes)]
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new TombOfNefertitiRespinZeroBetController(),
        () => new TombOfNefertitiFSRespinZeroBetController(),
        () => new FreespinZeroBetController(),
    ];

    SCREENS:(() => ScreenController)[] = [
        () => new TombOfNefertitiFreeSpinIntroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new TombOfNefertitiFreeSpinIntroView({
                    layer : TombOfNefertitiGameConfig.instance.LAYERS.FREE_SPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.4
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.5
                }, false);
            },
            autoCloseTime : 0
        }),
        () => new TombOfNefertitiFreeSpinOutroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new TombOfNefertitiFreeSpinOutroView({
                    layer : TombOfNefertitiGameConfig.instance.LAYERS.FREE_SPIN_OUTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.4
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.5
                }, false);
            },
            autoCloseTime : 0
        })];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => new TombOfNefertitiReelStopPresentationController(index, "reelStopPresentation")
    ];

    BEFORE_SPIN_STOP_PRESENTATIONS:((index:number) => BeforeSpinStopPresentationController)[] = [
        (index:number) => new TombOfNefertitiRandomCursePresentationController(index, "TombOfNefertitiRandomCursePresentationController"),
        (index:number) => new TombOfNefertitiWildRaidPresentationController(index, "TombOfNefertitiWildRaidPresentationController")
    ];

    constructor() {
        if(TombOfNefertitiGameModuleConfig.instance) {
            throw new Error("TombOfNefertitiGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    SERVER_PARSER:() => ServerDataParser = () => {
        return new TombOfNefertitiServerDataParser();
    };

    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new TombOfNefertitiParsedInitData(data, <TombOfNefertitiServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new TombOfNefertitiParsedGameData(data, <TombOfNefertitiServerDataParser>dataParser);

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):StateReelSymbol => {
            return new StateReelSymbol(symName, reelId, state);
        });

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => new TombOfNefertitiReelSymbolStateCreator();

    INTRO_VIEW:(onClickCallback:() => void) => TombOfNefertitiIntroView =
        (onClickCallback:() => void) => new TombOfNefertitiIntroView({
            layer : TombOfNefertitiGameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            backgroundTextures : {
                desktop : {landscape : TombOfNefertitiGameAssets.BACKGROUND}
            },
            featureIcons : {
                icons : [IntroFeatureLogo.VOLATILITY_MEDIUM]
            },
            mobileScale : 1.2,
            portraitScale : 1.7
        });

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new TombOfNefertitiBetLineWinIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0;
        }
    });

    GAME_FEATURE_CREATOR:() => void = () => {
        TombOfNefertitiGameModuleConfig.gameTweakerTest = new GameTweakerTest();

        TombOfNefertitiGameModuleConfig.background = new TombOfNefertitiBackground({
            layer : TombOfNefertitiGameConfig.instance.LAYERS.BACKGROUND.name
        });

        TombOfNefertitiGameModuleConfig.animatedWinlineController = new TombOfNefertitiAnimatedWinlineController();
        TombOfNefertitiGameModuleConfig.logo = new TombOfNefertitiLogo();
        TombOfNefertitiGameModuleConfig.attention = new TombOfNefertitiScatterAttentionController();
        TombOfNefertitiGameModuleConfig.multiplier = new TombOfNefertitiMultiplier();
        TombOfNefertitiGameModuleConfig.gameShaker = new TombOfNefertitiGameShaker();

        new TombOfNefertitiSymbolIdleAnimationController();
        new TombOfNefertitiMainGameIdleAnimationController();

        TombOfNefertitiGameModuleConfig.betLinesView = new TombOfNefertitiBetLinesView(
            {
                map : [
                    22, 2, 24, 4, 26, 6, 32, 12, 35, 1, 37, 8, 38, 9, 21, 3, 23, 5, 25, 7,// left
                    31, 16, 33, 19, 34, 20, 36, 10, 27, 11, 28, 14, 29, 15, 30, 13, 39, 17, 40, 18 // right
                ]
            },
            (index:number):TombOfNefertitiTextBetlineNumber => {
                return new TombOfNefertitiTextBetlineNumber(index, {
                    layer : TombOfNefertitiGameConfig.instance.LAYERS.REEL_BACKGROUND.name,
                    width : 20,
                    height : 20,
                    horizontalPadding : GameConfig.instance.REEL_AREA_POS_X - 33 + TombOfNefertitiGameConfig.instance.X_OFFSET,
                    verticalPadding : [
                        GameConfig.instance.REEL_AREA_POS_Y + 8,
                        (GameConfig.instance.GAME_HEIGHT - (GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.REEL_AREA_HEIGHT)) + 10
                    ],
                    textStyleNormal : {
                        fontFamily : "Open Sans",
                        fontSize : 15,
                        fill : "#ffffff",
                        dropShadow : true,
                        dropShadowAlpha : 0.75,
                        dropShadowAngle : 90,
                        dropShadowBlur : 6,
                        dropShadowColor : "#000",
                        dropShadowDistance : 4
                    },
                    textStyleWin : {
                        fontFamily : "Open Sans",
                        fontSize : 18,
                        fill : "#ffffff",
                        stroke : "#dfb8cd",
                        strokeThickness : 2,
                        dropShadow : true,
                        dropShadowAlpha : 0.75,
                        dropShadowAngle : 90,
                        dropShadowBlur : 6,
                        dropShadowColor : "#000",
                        dropShadowDistance : 4,
                        padding : 4

                    },
                    textWinScale : 1
                });
            },
            (index:number, numberPosition:number[], betLineData:number[]):TombOfNefertitiPolyBetline => {
                return new TombOfNefertitiPolyBetline(index, numberPosition, betLineData, {
                    staticLineLayer : TombOfNefertitiGameConfig.instance.LAYERS.BET_LINES.name,
                    styles : [
                        {
                            "lineWidth" : 3,
                            "color" : 0xffffff,
                            "alpha" : 1
                        },
                        {
                            "lineWidth" : 1,
                            "color" : 0xdfb8cd,
                            "alpha" : 1
                        }
                    ],
                    numberOffsetX : 20,
                    pointOverlapVerticalOffset : 8
                });
            }
        );
        StageManager.legacyScaling = true;
    };

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new TombOfNefertitiReelController(reelId);

    SPIN_CONTROLLER:() => SpinController = () => new TombOfNefertitiSpinController();

    REELS:() => Reels = () => new TombOfNefertitiReels();

    REEL_AREA_VIEW:() => ReelAreaView = () => new TombOfNefertitiReelAreaView();

    REEL_PART_ANIMATOR:(reelId:number) => SpinReelPartAnimator = reelId => new TombOfNefertitiReelPartAnimator(reelId);
}